import { getAppMenuItem, getIconWithBookmark, MenuItem } from 'components/atoms';
import { routesPl } from 'consts/paths/routesPl';
import { appPaths, LOGOUT_PATH } from 'consts/paths/paths';
import { AccountModuleIcon, LogOutModuleIcon } from 'assets';
import { authTexts } from 'consts/text';

const logoutMenuItem = getAppMenuItem(
    authTexts.logoutButtonLabel,
    LOGOUT_PATH,
    getIconWithBookmark(<LogOutModuleIcon />),
);

export const staffAccountManageMenuItems: MenuItem[] = [
    getAppMenuItem(
        routesPl.app.account.base,
        appPaths.app.account.base,
        getIconWithBookmark(<AccountModuleIcon />),
    ),
    logoutMenuItem,
];

export const parentAccountManageMenuItems: MenuItem[] = [
    getAppMenuItem(
        routesPl.app.parent.account.base,
        appPaths.app.parent.account.base,
        getIconWithBookmark(<AccountModuleIcon />),
    ),
    logoutMenuItem,
];

export const adminAccountManageMenuItems: MenuItem[] = [
    getAppMenuItem(
        routesPl.app.admin.account.base,
        appPaths.app.admin.account.base,
        getIconWithBookmark(<AccountModuleIcon />),
    ),
    logoutMenuItem,
];
